/** @format */

import React, { memo, Suspense } from "react";
import { Subject } from "../../types";

const SubjectIcon: React.FC<
  { subject: Subject } & React.SVGAttributes<SVGElement>
> = ({ subject, ...props }) => {
  const resolveSubjectId = (subjectId: string) => {
    let _subjectId = subjectId;

    switch (_subjectId) {
      case "mathematics-and-numeracy":
      case "maths":
        _subjectId = "mathematics";
        break;
      case "rs-buddhism":
      case "rs-christianity":
      case "rs-hinduism":
      case "rs-islam":
      case "rs-judaism":
      case "rs-sikhism":
        _subjectId = "religious-studies";
        break;
      case "core-cymraeg":
        _subjectId = "welsh-second";
        break;
    }

    return _subjectId;
  };

  const Icon = React.lazy(() =>
    import(`./icons/${resolveSubjectId(subject.id)}`).catch(
      (err) => import(`./icons/english-literature`),
    ),
  );

  return (
    <Suspense
      fallback={
        <>
          <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
          ></svg>
        </>
      }
    >
      <Icon {...props} />
    </Suspense>
  );
};

export default memo(SubjectIcon);
